import type FreeBusyRow from '../schema/FreeBusyRow';
import freeBusyCache from '../cacheV1/freeBusyCache';

export function initializeCache(store: Map<string, Map<string, FreeBusyRow>>): void {
    freeBusyCache.initialize(store);
}

export function isCacheInitialized(): boolean {
    return freeBusyCache.isInitialized();
}
